export const dataHooks = {
    menuArrow: 'input-menu-arrow',
    status: 'input-status',
    statusIndicatorTooltip: 'status-indicator-tooltip',
    suffixes: 'input-suffixes',
    tooltip: 'input-suffix-tooltip',
};
export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const STATUS = {
    error: 'error',
    warning: 'warning',
    loading: 'loading',
};
export const BORDER = {
    standard: 'standard',
    round: 'round',
    bottomLine: 'bottomLine',
    none: 'none',
};
//# sourceMappingURL=Input.constants.js.map